import React from 'react';

const MenuBarIcon = () => {
  return (
    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.5C0 0.671573 0.671573 0 1.5 0H15.5C16.3284 0 17 0.671573 17 1.5C17 2.32843 16.3284 3 15.5 3H1.5C0.671573 3 0 2.32843 0 1.5ZM0 7.5C0 6.67157 0.671573 6 1.5 6H15.5C16.3284 6 17 6.67157 17 7.5C17 8.32843 16.3284 9 15.5 9H1.5C0.671573 9 0 8.32843 0 7.5ZM1.5 12C0.671573 12 0 12.6716 0 13.5C0 14.3284 0.671573 15 1.5 15H15.5C16.3284 15 17 14.3284 17 13.5C17 12.6716 16.3284 12 15.5 12H1.5Z" fill="#C0C0C0"/>
    </svg>
  );
};

export default MenuBarIcon;
